import request from '@/utils/request'

//search7010List
export function search7010List(param) {
    let data = param
    return request({
      url: `/v20/v20d7010Controller/search7010List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}

//getShipNo
export function getShipNo(param) {
    let data = param
    return request({
      url: `/v20/v20d7010Controller/getShipNo`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}


//Update Block Actual Result 
export function UpdateBlockSchedule(param) {
  let data = param  
  return request({
      url:  `/v20/v20d7010Controller/UpdateBlockSchedule`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  })
}

